import React from 'react'
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { BsInfoSquare } from "react-icons/bs";


function VoiceReport() {
    return (
        <>
            <div className='w-[100%] shadow-[0_2px_8px_rgba(0,0,0,0.1)]  rounded-lg p-6'>
                <div className='w-[100%] flex flex-wrap gap-4'>

                    <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>From Date:</label>
                        <input
                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="Date"
                        />
                    </div>
                    <div className='w-full sm:w-[48%] lg:w-[24%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>To Date:</label>
                        <input
                            className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                            type="Date"
                        />
                    </div>
                    <div className='w-full sm:w-[48%] lg:w-[24%] flex items-center gap-1 mt-4'>
                        <button

                            className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'
                        >
                            <FaFilter /> <span className='text-[12px] font-bold'>Apply Filter</span>
                        </button>

                        <button
                            className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                        >
                            <TbReload /> <span className='text-[12px] font-bold'>Clear </span>
                        </button>
                    </div>

                </div>
                <div className='w-[100%] border-[#e0e0e0] flex justify-between  border-b-[1px] border-t-[1px] py-4 mt-4 flex-wrap'>
                    <span className='text-[14px] font-bold'>Downloaded Reports (Voice)</span>
                    <div className='bg-[#f8f0f0] p-[9px] border-l-[0.25rem] border-[#713737] w-[100%] sm:w-[300px]  flex items-center rounded-lg "'>
                        <BsInfoSquare />
                        <span className='text-[12px] ml-2 text-red-600 italic '> Please note: expires in 7 days.
                        </span>
                    </div>
                    
                </div>
                <p className='w-[100%] text-[14px] text-center text-[#858c97]'>No files found in the selected date range.</p>
            </div>
        </>
    )
}

export default VoiceReport
